import { inertNewTabHandle } from '../providers/IoContext';
export const makeNativeOpenNewTab = (openExternalUrl, reportRefusedUrl)=>(url)=>{
        void openExternalUrl(url).then((opened)=>{
            if (!opened) {
                reportRefusedUrl(url);
            }
        });
        return inertNewTabHandle;
    };
export const makeOpenNewTab = (windowOpen)=>(url, opts)=>{
        if (opts === null || opts === void 0 ? void 0 : opts.trackable) {
            const win = windowOpen(url, '_blank');
            return {
                close: ()=>win === null || win === void 0 ? void 0 : win.close(),
                isClosed: ()=>{
                    var _ref;
                    return (_ref = win === null || win === void 0 ? void 0 : win.closed) !== null && _ref !== void 0 ? _ref : true;
                }
            };
        }
        windowOpen(url, '_blank', 'noopener,noreferrer');
        return {
            close: ()=>{},
            isClosed: ()=>true
        };
    };
export const makeOpenPendingTab = (windowOpen)=>()=>{
        const openedWindow = windowOpen('', '_blank');
        if (openedWindow) {
            openedWindow.opener = null;
        }
        return {
            navigate: (url)=>openedWindow ? openedWindow.location.replace(url) : windowOpen(url, '_blank', 'noopener,noreferrer'),
            close: ()=>openedWindow === null || openedWindow === void 0 ? void 0 : openedWindow.close()
        };
    };
export const makeNativeOpenPendingTab = (openNewTab)=>()=>({
            navigate: (url)=>{
                openNewTab(url);
            },
            close: ()=>{}
        });
